export enum Status {
  IDLE,
  LOADING,
  SUCCEEDED,
  FAILED
}

/* Enums allow a developer to define a set of named constants.
Using enums can make it easier to document intent, or create a set of distinct cases.
TypeScript provides both numeric and string-based enums */